// extracted by mini-css-extract-plugin
export default {"preview-wrapper":"Proposals_preview-wrapper__fgcT2","proposed-container":"Proposals_proposed-container__DhJ8P","loading-value":"Proposals_loading-value__emBsi"};